import { Button } from '@xver/components/Atoms';
import { useTranslation } from 'react-i18next';

/**
 * Shown instead of an empty table when the volume list request failed. A retry unmounts this block
 * (the query goes back to pending), so onRetry must move focus itself: somewhere stable on success,
 * back to `retryButtonId` when the error returns.
 */
export default function VolumesLoadError({
    onRetry,
    retryButtonId,
}: {
    onRetry: () => void | Promise<void>;
    retryButtonId: string;
}) {
    const { t } = useTranslation('blockStorage');
    return (
        <div role="alert" className="w-full p-4 flex flex-wrap items-center gap-3 text-sm">
            <span>{t('page.loadFailed')}</span>
            <Button id={retryButtonId} size="lg" variant="secondary" onClick={() => void onRetry()}>
                {t('page.retry')}
            </Button>
        </div>
    );
}
